import React, { Component } from 'react';
import ComponentAuditLog from '../../ComponentAuditLog';
import ComponentName from '../../../constant/ComponentName';

class ComponentAudits extends Component {
  render() {
    return <ComponentAuditLog isAdminPage canPreview previewComponentDetail />;
  }
}

export default ComponentAudits;
